import React from "react";
import { ProductLicense } from "./update-tool.types";

interface ProductLicensesTableProps {
  productLicenses: ProductLicense[];
  onAddNewProduct?: (tool: any, productId: any, search: string) => void;
}

const ProductLicensesTable: React.FC<ProductLicensesTableProps> = ({
  productLicenses,
  onAddNewProduct,
}) => {
  if (productLicenses.length === 0) {
    return null;
  }

  return (
    <>
      <h2 className="update-tool-form__heading">
        Product Licenses
      </h2>
      <div
        className="update-tool-form__table"
        role="table"
        aria-label="Product licenses table"
      >
        <div
          className="update-tool-form__table-header"
          role="row"
        >
          <div
            className="update-tool-form__table-cell update-tool-form__table-cell--product"
            role="columnheader"
          >
            <div className="update-tool-form__table-cell-header">
              Product
            </div>
          </div>
          <div
            className="update-tool-form__table-cell update-tool-form__table-cell--quantity"
            role="columnheader"
          >
            <div className="update-tool-form__table-cell-header">
              Qty
            </div>
          </div>
          <div
            className="update-tool-form__table-cell update-tool-form__table-cell--total"
            role="columnheader"
          >
            <div className="update-tool-form__table-cell-header">
              Total
            </div>
          </div>
        </div>
        {productLicenses.map((license) => (
          <div
            key={license.id}
            className="update-tool-form__table-row"
            role="row"
          >
            <div 
              className="update-tool-form__table-cell update-tool-form__table-cell--product"
              role="cell"
            >
              <div 
                className={onAddNewProduct ? "update-tool-form__table-cell-content update-tool-form__table-cell-content--clickable" : "update-tool-form__table-cell-content"}
                onClick={() => {
                  if (onAddNewProduct) {
                    const productId = parseInt(license.id, 10) || 0;
                    onAddNewProduct({}, productId, license.name);
                  }
                }}
              >
                {license.name}
              </div>
            </div>
            <div
              className="update-tool-form__table-cell update-tool-form__table-cell--quantity"
              role="cell"
            >
              <div className="update-tool-form__table-cell-content">
                {license.quantity}
              </div>
            </div>
            <div
              className="update-tool-form__table-cell update-tool-form__table-cell--total"
              role="cell"
            >
              <div className="update-tool-form__table-cell-content">
                {license.pricePerUnit}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default ProductLicensesTable;

